import toast from "react-hot-toast";
import config from "@/config";
import { OlkyToken } from "../kycoin/types";

export const linkTokenToWallet = async (olkyToken: OlkyToken, image?: string) => {
  if (!window.ethereum) {
    toast.error("Error");
    return;
  }
  await switchNetwork();

  const tokenAddress = olkyToken.token_address;
  const tokenSymbol = olkyToken.native_symbol ?? olkyToken.symbol;
  const tokenDecimals = olkyToken.decimal;

  try {
    await window.ethereum.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: tokenAddress,
          symbol: tokenSymbol,
          decimals: tokenDecimals,
          image: image ?? config.TOKEN_IMAGE
        }
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export async function switchNetwork() {
  const chainId = window.ethereum.chainId;
  if (chainId !== config.SITE_NETCHAIN_ID) {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: config.SITE_NETCHAIN_ID }]
    });
  }
}

export function isEtherActive() {
  const { ethereum } = window;
  return !!ethereum;
}
